import { InjectionToken } from '@angular/core';

export let WIT_API_PROXY = new InjectionToken<string>('fabric8.wit.api.proxy');
